<script lang="ts">
  import { AppState } from '../../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="40" height="40" rx="8" fill={primary600} />
  <path
    d="M27 25.6675V30.3341"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M24.666 28.001H29.3327"
    stroke={primary200}
    stroke-width="1.90909"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M24.2344 10H20.683V23.6232C20.683 25.2464 19.317 26.5797 17.6172 26.5797C15.9174 26.5797 14.5514 25.2464 14.5514 23.6232C14.5514 22.029 15.887 20.7246 17.5262 20.6667V17.2464C13.914 17.3043 11 20.1159 11 23.6232C11 27.1594 13.9747 30 17.6476 30C21.3204 30 24.2951 27.1304 24.2951 23.6232V16.6377C25.6307 17.5652 27.2698 18.1159 29 18.1449V14.7246C26.3289 14.6377 24.2344 12.5507 24.2344 10Z"
    fill={primary200}
  />
</svg>
